import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import thetaMinus60 from "./components/theta--60";
import thetaMinus50 from "./components/theta--50";
import thetaMinus40 from "./components/theta--40";
import thetaMinus30 from "./components/theta--30";
import thetaMinus20 from "./components/theta--20";
import thetaMinus10 from "./components/theta--10";
import theta0 from "./components/theta-0";
import theta10 from "./components/theta-10";
import theta20 from "./components/theta-20";
import theta30 from "./components/theta-30";
import theta40 from "./components/theta-40";
import theta50 from "./components/theta-50";
import theta60 from "./components/theta-60";
import theta70 from "./components/theta-70";
import theta80 from "./components/theta-80";
import theta90 from "./components/theta-90";
import theta100 from "./components/theta-100";
import theta110 from "./components/theta-110";
import theta120 from "./components/theta-120";

const principle: Slide = {
  descriptionHtml:
    "A plane wave propagates in the air (in free space) along the direction s<sub>0</sub>. If you look at this plane wave from another point of view, i.e. along the direction s, its apparent wavelength and apparent phase velocity change. You can change the direction s relative to the direction s<sub>0</sub> by changing the relative angle between the two directions θ. Look at how the phase velocity c<sub>φ</sub> changes with θ. It could even become negative!",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: {},
          items: [
            { name: "Relative angle θ = -60°" },
            { name: "Relative angle θ = -50°" },
            { name: "Relative angle θ = -40°" },
            { name: "Relative angle θ = -30°" },
            { name: "Relative angle θ = -20°" },
            { name: "Relative angle θ = -10°" },
            { name: "Relative angle θ = 0°" },
            { name: "Relative angle θ = 10°" },
            { name: "Relative angle θ = 20°" },
            { name: "Relative angle θ = 30°" },
            { name: "Relative angle θ = 40°" },
            { name: "Relative angle θ = 50°" },
            { name: "Relative angle θ = 60°" },
            { name: "Relative angle θ = 70°" },
            { name: "Relative angle θ = 80°" },
            { name: "Relative angle θ = 90°" },
            { name: "Relative angle θ = 100°" },
            { name: "Relative angle θ = 110°" },
            { name: "Relative angle θ = 120°" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
      components: [
        thetaMinus60,
        thetaMinus50,
        thetaMinus40,
        thetaMinus30,
        thetaMinus20,
        thetaMinus10,
        theta0,
        theta10,
        theta20,
        theta30,
        theta40,
        theta50,
        theta60,
        theta70,
        theta80,
        theta90,
        theta100,
        theta110,
        theta120,
      ],
    },
  },
};

export default principle;
